/** Password rules, as the API checks them (Account/sign-in/reset and accept-invite). */

export const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export const isEmail = (email: string): boolean => EMAIL_PATTERN.test(email.trim());

export type TRule = { label: string; ok: boolean };

export const passwordRules = (password: string, email: string | null | undefined): TRule[] => {
  const local = (email || '').split('@')[0].trim().toLowerCase();
  return [
    { label: 'At least 8 characters', ok: password.length >= 8 },
    { label: 'A number or symbol', ok: /[0-9\W_]/.test(password) },
    { label: 'Not your email address', ok: !!password && (!local || !password.toLowerCase().includes(local)) },
  ];
};

export const passwordOk = (password: string, email: string | null | undefined): boolean =>
  passwordRules(password, email).every((rule) => rule.ok);

/** "A, B and C". */
export const joinAnd = (items: string[]): string =>
  items.length <= 1 ? items.join('') : `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;

export const initialsOf = (name: string): string =>
  name.split(/\s+/).filter(Boolean).slice(0, 2).map((word) => word[0].toUpperCase()).join('');
